module.exports = __webpack_public_path__ + "static/media/Female whisky drinker woman at a bar-0924 (credit OurWhisky Foundation_Jo Hanley).8f99fb67.jpg";